export const mdl = require("./mdl.png");
export const international = require("./the_international_logo.png");



// WEBPACK FOOTER //
// ./src/assets/images/league/index.js